"use client"

import { usePathname, useRouter } from "next/navigation"
import { useLocale, useTranslations } from "next-intl"
import { Globe } from "lucide-react"
import { Button } from "@/components/ui/button"

export function LanguageSwitcher() {
  const locale = useLocale()
  const t = useTranslations("languageSwitcher")
  const router = useRouter()
  const pathname = usePathname()
  const switchLanguage = () => {
    const newLocale = locale === "pl" ? "en" : "pl"
    const pathWithoutLocale = pathname.replace(/^\/(pl|en)/, "") || "/"
    router.push(`/${newLocale}${pathWithoutLocale}`)
  }
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={switchLanguage}
      className="flex items-center gap-2 hover:bg-purple-950 hover:text-purple-400 transition-colors"
      aria-label={t("label")}
    >
      <Globe className="h-4 w-4" />
      <span className="text-sm font-medium">{t("target")}</span>
    </Button>
  )
}
